
import Vue, { PropType } from 'vue';
import { Wrapper } from './styles';

interface ActionProps {
  icon: string;
  text: string;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  click: (data: any, evt: Event) => void;
}

interface LabelProps {
  title: string;
  subTitle: string;
}

export default Vue.extend({
  name: 'CardItem',
  components: {
    Wrapper,
  },
  props: {
    label: {
      type: Object as PropType<LabelProps>,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    imgUrl: {
      type: String,
      default: '',
    },
    actions: {
      type: Array as PropType<ActionProps[]>,
      default: () => [],
    },
  },
  computed: {
    resultValues(): LabelProps {
      return {
        title: this.data[this.label.title],
        subTitle: this.data[this.label.subTitle],
      };
    },
  },
  data() {
    return {
      loading: true,
      isVisible: true,
      url: '',
    };
  },
  watch: {
    imgUrl(value) {
      this.url = value;
      this.isVisible = true;
    },
  },
});
